import React from 'react';
import { IonButton, IonContent, IonFooter } from '@ionic/react';
import { Formik, Form } from 'formik';

import { Text } from '$gintl';
import userModel from '$gbusiness/models/user';
import { FormSection } from '$gcomponents/reusables';
import { input } from '$gbusiness/helpers';
import { Wrapper } from '$gstyles';

import { USER_FORM } from './userForm';

interface FormViewProps {
  user: userModel;
  onSubmit: Function;
}

const FormView: React.FC<FormViewProps> = ({ user, onSubmit }) => {
  const initialValues = input.deriveFormInitialValues(USER_FORM, user);

  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      onSubmit={(values) => {
        onSubmit(user?.userId, values);
      }}>
      {(formik) => (
        <>
          <IonContent>
            <Wrapper maxWidth="800px">
              <Form>
                <FormSection FORM={USER_FORM} formik={formik} />
              </Form>
            </Wrapper>
          </IonContent>
          <IonFooter>
            <IonButton
              onClick={() => {
                formik.handleSubmit();
              }}
              disabled={!formik.dirty}
              expand="block">
              <Text k="SCREEN.USER.SAVE_BUTTON" />
            </IonButton>
          </IonFooter>
        </>
      )}
    </Formik>
  );
};

export default FormView;
